import React, { memo, useMemo, useCallback } from "react"

import { useApp } from "../../../hooks/useApp"
import { usePage } from "../../../hooks/usePage"

export const withAccountDrawer = Component =>
  memo(({ name = "AccountDrawer" }: any) => {
    const { orders: ordersPage, preferences: preferencesPage } = usePage()

    const { globalStateReducer } = useApp()

    const [{ activeCart, activeAccount }, dispatch] = globalStateReducer

    const handleAccountActive = useCallback(() => {
      dispatch({
        type: "setActiveAccount",
        payload: !activeAccount,
      })
    }, [activeAccount, dispatch])

    Component.displayName = name
    return useMemo(
      () => (
        <Component
          activeCart={activeCart}
          activeAccount={activeAccount}
          handleAccountActive={handleAccountActive}
          ordersPage={ordersPage}
          preferencesPage={preferencesPage}
        />
      ),
      [activeCart, activeAccount, handleAccountActive, ordersPage, preferencesPage]
    )
  })
